@file:OptIn(ExperimentalJsExport::class)
package game

// 游戏常量
@JsExport
object GameConfig {
    // 场地边界(扩大地图)
    const val ARENA_SIZE = 120.0
    const val ARENA_HALF = ARENA_SIZE / 2

    // 坦克
    const val TANK_RADIUS = 1.4
    const val BASE_PLAYER_SPEED = 10.0
    const val BASE_ENEMY_SPEED = 5.5
    const val TURN_SPEED = 2.6           // 弧度/秒
    const val FIRE_COOLDOWN = 0.6        // 秒
    const val BASE_PLAYER_HP = 100
    const val BASE_ENEMY_HP = 40

    // ===== 底盘(轻/中/重甲)=====
    // 速度倍率 / 血量倍率 / 护甲减伤
    const val LIGHT_SPEED_MULT = 1.35
    const val LIGHT_HP_MULT = 0.8
    const val LIGHT_ARMOR = 10
    const val MEDIUM_SPEED_MULT = 1.0
    const val MEDIUM_HP_MULT = 1.0
    const val MEDIUM_ARMOR = 25
    const val HEAVY_SPEED_MULT = 0.75
    const val HEAVY_HP_MULT = 1.45
    const val HEAVY_ARMOR = 45

    // 底盘价格
    const val CHASSIS_MEDIUM_PRICE = 150
    const val CHASSIS_HEAVY_PRICE = 400

    // ===== 子弹 =====
    const val BULLET_LIFE = 1.8
    const val BULLET_RADIUS = 0.35

    // 标准炮弹
    const val STANDARD_SPEED = 22.0
    const val STANDARD_DAMAGE = 15

    // 激光:高速穿透
    const val LASER_SPEED = 45.0
    const val LASER_DAMAGE = 8
    const val LASER_PIERCE = 3

    // 导弹:高伤 + 爆炸范围
    const val MISSILE_SPEED = 14.0
    const val MISSILE_DAMAGE = 30
    const val MISSILE_RADIUS = 4.0
    const val MISSILE_LIFE = 3.0

    // 追踪弹:自动转向最近敌人
    const val HOMING_SPEED = 16.0
    const val HOMING_DAMAGE = 20
    const val HOMING_TURN = 4.0

    // 近战电击:近距离扇形伤害
    const val MELEE_RADIUS = 5.0
    const val MELEE_DAMAGE = 35
    const val MELEE_ARC = 0.6           // 弧度
    const val MELEE_COOLDOWN = 1.2

    // 霰弹:多弹片散射
    const val SHOTGUN_SPEED = 18.0
    const val SHOTGUN_DAMAGE = 8
    const val SHOTGUN_PELLETS = 6
    const val SHOTGUN_SPREAD = 0.10     // 散射角(较小,更集中)

    // 等离子弹:高伤慢速
    const val PLASMA_SPEED = 12.0
    const val PLASMA_DAMAGE = 40
    const val PLASMA_LIFE = 2.5

    // 加特林:超快射速低伤
    const val GATLING_SPEED = 30.0
    const val GATLING_DAMAGE = 6
    const val GATLING_COOLDOWN = 0.09

    // EMP:眩晕范围
    const val EMP_SPEED = 14.0
    const val EMP_DAMAGE = 10
    const val EMP_RADIUS = 6.0
    const val EMP_STUN_TIME = 2.0

    // 榴弹炮:弧形弹道,落地范围爆炸
    const val GRENADE_SPEED = 16.0
    const val GRENADE_DAMAGE = 28
    const val GRENADE_RADIUS = 4.5
    const val GRENADE_LIFE = 1.6

    // 火焰炮:燃烧持续伤害
    const val FLAME_SPEED = 20.0
    const val FLAME_DAMAGE = 6
    const val FLAME_BURN_TIME = 3.0
    const val FLAME_BURN_TICK = 1.0      // 每秒燃烧伤害次数
    const val FLAME_LIFE = 1.2
    
    // ===== 🚀 湮灭之核 (OBLIVION) =====
    const val OBLIVION_SPEED = 100.0          // 光速飞行
    const val OBLIVION_DAMAGE = 99999         // 毁天灭地的伤害
    const val OBLIVION_RADIUS = 50.0          // 半屏爆炸范围
    const val OBLIVION_LIFE = 5.0             // 超长寿命
    const val OBLIVION_PIERCE = 999           // 无限穿透
    const val OBLIVION_PRICE = 999999         // 💰 价格 999999 金币
    const val OBLIVION_COOLDOWN = 0.01        // 几乎无冷却
    const val OBLIVION_MULTI_SHOT = 12        // 多重射击数量

    // 武器价格(标准默认拥有)
    const val WEAPON_LASER_PRICE = 300
    const val WEAPON_MISSILE_PRICE = 500
    const val WEAPON_HOMING_PRICE = 700
    const val WEAPON_MELEE_PRICE = 900
    const val WEAPON_SHOTGUN_PRICE = 250
    const val WEAPON_PLASMA_PRICE = 600
    const val WEAPON_GATLING_PRICE = 450
    const val WEAPON_EMP_PRICE = 800
    const val WEAPON_GRENADE_PRICE = 650
    const val WEAPON_FLAME_PRICE = 550

    // 关卡
    const val BASE_ENEMY_COUNT = 3

    // 3D 相机(第三人称俯视)
    const val CAMERA_DISTANCE = 9.0      // 相机与坦克的水平距离
    const val CAMERA_HEIGHT = 6.0        // 相机高度(俯视)
    const val CAMERA_FOV = 70.0
    const val MOUSE_SENSITIVITY = 0.004  // 鼠标水平灵敏度
    const val PITCH_SPEED = 0.9          // Q/E 俯仰速度(弧度/秒)
    const val PITCH_MIN = 0.15           // 俯仰下限(更俯视)
    const val PITCH_MAX = 1.3            // 俯仰上限(更平视)

    // ===== Y 轴(跳跃)=====
    const val JUMP_SPEED = 9.0        // 起跳初速度
    const val GRAVITY = -24.0         // 重力加速度
    const val JUMP_DODGE_HEIGHT = 1.6 // 高于此高度子弹命中失效

    // ===== 道具 =====
    const val POWERUP_SPAWN_INTERVAL = 5.0
    const val POWERUP_MAX_ON_FIELD = 3
    const val POWERUP_LIFE = 15.0
    const val POWERUP_RADIUS = 1.2
    const val BUFF_DURATION = 8.0
    const val SPEED_BUFF_MULT = 1.5
    const val RAPID_BUFF_MULT = 0.4
    const val MULTI_SHOT_COUNT = 3
    const val MULTI_SHOT_ANGLE = 0.35

    // ===== 技能 =====
    const val DASH_SPEED_MULT = 3.0
    const val DASH_DURATION = 0.35
    const val DASH_COOLDOWN = 5.0
    const val SHIELD_SKILL_DURATION = 3.0
    const val SHIELD_SKILL_COOLDOWN = 15.0
    const val NUKE_DAMAGE = 40
    const val NUKE_RADIUS = 999999.0
    const val NUKE_COOLDOWN = 20.0

    // ===== 能量系统 =====
    const val MAX_ENERGY = 100.0
    const val ENERGY_REGEN = 12.0        // 每秒恢复
    const val ENERGY_DASH_COST = 25.0
    const val ENERGY_SHIELD_COST = 40.0
    const val ENERGY_NUKE_COST = 60.0

    // ===== 金币 =====
    const val KILL_REWARD = 50
    const val WAVE_BONUS = 100
    const val START_COINS = 200
    // 被动收入:每 INCOME_INTERVAL 秒自动获得 INCOME_AMOUNT 金币(存活工资)
    const val INCOME_INTERVAL = 5.0
    const val INCOME_AMOUNT = 20
}
